import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Container from "@material-ui/core/Container";
import ConfirmationDialog from "./ConfirmationDialog";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useContext, useState } from "react";
import NumberFormat from "react-number-format";
import { AppContext } from "../views/App";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useEffect } from "react";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Hidden from "@material-ui/core/Hidden";

const drawerWidth = "100vw";

const useStyles = makeStyles(theme => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#fafafa"
  },
  backButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  },
  card: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(0)
    }
  },
  button: {
    width: 120,
    marginLeft: "auto"
  },
  mobileContainer: {
    paddingTop: theme.spacing(2)
  }
}));

const DeliveryServiceDetails = ({ service, loading = false, onDelete, onSave, onClose }) => {
  const classes = useStyles();
  const { comunas } = useContext(AppContext);

  const [name, setName] = useState("");
  const [selectedComunas, setSelectedComunas] = useState([]);
  const [fee, setFee] = useState("");
  const [conditions, setConditions] = useState("");

  const [validName, setValidName] = useState({ valid: true, msg: "" });
  const [validComunas, setValidComunas] = useState({ valid: true, msg: "" });
  const [validFee, setValidFee] = useState({ valid: true, msg: "" });
  const [validConditions, setValidConditions] = useState({ valid: true, msg: "" });

  const [openConfirmation, setOpenConfirmation] = useState(false);

  useEffect(() => {
    if (service) {
      setName(service.name);
      setSelectedComunas(service.comunas);
      setFee(service.fee >= 0 ? service.fee : 0);
      setConditions(service.conditions);

      setValidName({ valid: true, msg: "" });
      setValidComunas({ valid: true, msg: "" });
      setValidFee({ valid: true, msg: "" });
      setValidConditions({ valid: true, msg: "" });
    }
  }, [service]);

  const validateName = () => {
    let valid = true;
    let msg = "";

    if (name.length < 3) {
      valid = false;
      msg = "El nombre no puede ser menos de 3 caracteres";
    }

    return { valid, msg };
  };

  const validateComunas = () => {
    let valid = true;
    let msg = "";

    if (selectedComunas.length < 1) {
      valid = false;
      msg = "Debe seleccionar al menos 1 comuna";
    }

    return { valid, msg };
  };

  const validateFee = () => {
    let valid = true;
    let msg = "";

    if (fee < 0 || fee === "") {
      valid = false;
      msg = "Debe ingresar un valor mayor o igual a cero";
    }

    return { valid, msg };
  };

  const validateConditions = () => {
    let valid = true;
    let msg = "";

    if (conditions.length < 4) {
      valid = false;
      msg = "Las condiciones no puede ser menor de 4 caracteres";
    }
    return { valid, msg };
  };

  const handleSelectComunas = newComunas => {
    if (newComunas.length < 1)
      setValidComunas({ valid: false, msg: "Debe seleccionar al menos una comuna" });

    setSelectedComunas(newComunas);
  };

  const handleSave = () => {
    let canSave = true;
    const validName = validateName();
    const validComunas = validateComunas();
    const validFee = validateFee();
    const validConditions = validateConditions();

    if (!validName.valid) {
      setValidName(validName);
      canSave = false;
    }

    if (!validComunas.valid) {
      setValidComunas(validComunas);
      canSave = false;
    }

    if (!validFee.valid) {
      setValidFee(validFee);
      canSave = false;
    }

    if (!validConditions.valid) {
      setValidConditions(validConditions);
      canSave = false;
    }

    if (canSave) onSave(name, selectedComunas, Number(fee), conditions);
  };

  const renderContent = () => {
    return (
      <Card className={classes.card}>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                required
                disabled={loading}
                label="Nombre"
                placeholder="Ej: Zona centro"
                value={name}
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ maxLength: 100 }}
                onChange={({ target }) => setName(target.value)}
                onBlur={() => setValidName(validateName())}
                error={!validName.valid}
                helperText={!validName.valid && validName.msg}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                fullWidth
                multiple
                id="comunas"
                options={comunas}
                size="small"
                disabled={loading}
                value={selectedComunas}
                getOptionLabel={option => option.nombre}
                getOptionSelected={(option, value) => option.nombre === value.nombre}
                filterSelectedOptions
                renderInput={params => (
                  <TextField
                    {...params}
                    required
                    label="Localidad"
                    InputLabelProps={{
                      shrink: true
                    }}
                    onBlur={() => setValidComunas(validateComunas())}
                    error={!validComunas.valid}
                    helperText={!validComunas.valid && validComunas.msg}
                  />
                )}
                onChange={(event, obj, reason) => handleSelectComunas(obj)}
              />
            </Grid>
            <Grid item xs={12}>
              <NumberFormat
                fullWidth
                thousandSeparator="."
                decimalSeparator=","
                prefix="$"
                allowNegative={false}
                customInput={TextField}
                required
                label="Tarifa"
                placeholder="Ej: $7.000"
                disabled={loading}
                value={fee}
                size="small"
                inputProps={{
                  maxLength: 8
                }}
                InputLabelProps={{
                  shrink: true
                }}
                onValueChange={({ _, value }) => setFee(value)}
                onBlur={() => setValidFee(validateFee())}
                error={!validFee.valid}
                helperText={!validFee.valid && validFee.msg}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                multiline
                rows={2}
                disabled={loading}
                label="Términos y condiciones de entrega"
                placeholder="Ej: Despacho en 24 horas"
                value={conditions}
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ maxLength: 500 }}
                onChange={({ target }) => setConditions(target.value)}
                onBlur={() => setValidConditions(validateConditions())}
                error={!validConditions.valid}
                helperText={!validConditions.valid && validConditions.msg}
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          {loading ? (
            <Button className={classes.button} disabled={loading}>
              <CircularProgress size={25} />
            </Button>
          ) : (
            <>
              <Button
                className={classes.button}
                color="primary"
                disabled={loading}
                size="large"
                onClick={() => setOpenConfirmation(true)}
              >
                Eliminar
              </Button>
              <Button
                className={classes.button}
                color="primary"
                disabled={loading}
                size="large"
                onClick={handleSave}
              >
                Guardar
              </Button>
            </>
          )}
        </CardActions>
      </Card>
    );
  };

  return (
    <>
      <ConfirmationDialog
        title="Confirmación"
        open={openConfirmation}
        onOk={() => onDelete(service)}
        onCancel={() => setOpenConfirmation(false)}
      >
        ¿Seguro desea eliminar el servicio <strong>{name}</strong>?
      </ConfirmationDialog>

      <Hidden mdUp>
        <Drawer
          className={classes.drawer}
          open={Boolean(service)}
          anchor="right"
          classes={{
            paper: classes.drawerPaper
          }}
          onClose={onClose}
        >
          <AppBar position="sticky">
            <Toolbar>
              <IconButton
                className={classes.backButton}
                edge="start"
                color="inherit"
                onClick={onClose}
              >
                <ArrowBackIcon />
              </IconButton>

              <Typography className={classes.title} variant="h6">
                Editar servicio de despacho
              </Typography>
            </Toolbar>
          </AppBar>

          <Container className={classes.mobileContainer} maxWidth="sm">
            {renderContent()}
          </Container>
        </Drawer>
      </Hidden>

      <Hidden smDown>{service && renderContent()}</Hidden>
    </>
  );
};

export default DeliveryServiceDetails;
